import React from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Header from "./styles-forms/Header";
import Note from "./styles-forms/Note";
import { Grid, Card, CardContent } from "@material-ui/core";
import flow from "../../flow.svg";
import webpay from "../../webpay.svg";

import axios, { mensajeError } from "../../utils/axios";
import { evento, obtenerVisitorId } from "../../utils/matomo";

export default function ProcedureCharge({ canGoBack, handleBack }) {
  const { transaction, participant } = useParams();
  const participants = useSelector(({ documento }) => documento.documento.participants);
  const documento = useSelector(({ documento }) => documento.documento);
  const emailProc = useSelector(({ documento }) => documento.email);
  const gestores = useSelector(({ documento }) => documento.gestores);
  const pagosPorEtapa = useSelector(({ documento }) => documento.pagos_por_etapa);

  let participantData = null;
  if (participant && documento) {
    participantData = participants.find((it) => it.id === participant);
  } else if (documento) {
    participantData = participants[0];
  }

  let totalAmount = participantData.next["custom:charge_value"];

  if (participantData.next["custom:charge_by_sign"] && participantData.next["custom:charge_value"] !== "") {
    totalAmount =
      parseInt(totalAmount) +
      parseInt(participantData.next["custom:charge_by_sign"]) * parseInt(gestores[0].emails.length);
    if (!gestores[0].emails) {
      return (
        <div>
          <span>
            Antes de intentar realizar el cobro, se debe indicar quienes serán los firmantes (este cobro será en
            relación a cuantos firmantes haya en el documento)
          </span>
        </div>
      );
    }
  }

  /* Si ya pagó esta etapa y volvió atrás, solo se cobra la diferencia */
  const gestorActual = participant ? gestores.find((it) => it.id === participant) : gestores[0];
  const yaPagado = Number((pagosPorEtapa || {})[gestorActual && gestorActual.current]) || 0;
  const montoPendiente = Math.max((parseInt(totalAmount) || 0) - yaPagado, 0);

  const handleButton = (e) => {
    e.preventDefault();
    startPayment();
  };

  const startPayment = async () => {
    try {
      let participantDataGest = null;
      if (participant && documento) {
        participantDataGest = gestores.find((it) => it.id === participant);
      } else if (documento) {
        participantDataGest = gestores[0];
      }
      if (emailProc === undefined) {
        return alert(
          "No se ha iniciado sesión durante el procedimiento. Por favor comunicar a soporte para esta corrección."
        );
      }
      evento("Embudo", "Ir a pagar", documento._nameSchema, parseInt(totalAmount) || undefined);
      const { data } = await axios.post("/api/flow/create", {
        mtm_vid: obtenerVisitorId(),
        transaction,
        participant: participantDataGest.id,
        current: participantDataGest.current,
      });
      if (data.pagado) {
        // Nada más que cobrar: el servidor ya avanzó la etapa
        window.location.reload();
        return;
      }
      window.location.href = data.url + "?token=" + data.token;
    } catch (err) {
      alert(mensajeError(err, "Hubo un error al iniciar el pago"));
    }
  };

  return (
    <>
      <Header documento={documento} position={"center-"} />

      <Grid id="center-form" container direction="row" justify="center" alignItems="center">
        <Grid item xl={4} md={6} style={{ marginTop: "-138px", position: "initial", minWidth: "50%" }}>
          <Card
            className="mb-5 card-box card-box-border-bottom border-success justForm gd-pago-card"
            style={{ borderRadius: "25px" }}
          >
            <CardContent style={{ paddingLeft: "50px", paddingRight: "50px", display: "flex", flexFlow: "column" }}>
              {/* Resumen del pago: antes era una tabla con texto morado y azul sobre el fondo
                  oscuro (contraste 2,3:1 a 2,8:1) */}
              <div className="gd-pago">
                <h2 className="gd-pago__titulo">Pago</h2>
                <div className="gd-pago__fila">
                  <span>Documento</span>
                  <strong>{documento._nameSchema}</strong>
                </div>
                {yaPagado > 0 && (
                  <div className="gd-pago__fila">
                    <span>Ya pagado</span>
                    <strong>${new Intl.NumberFormat("de-DE").format(yaPagado)}</strong>
                  </div>
                )}
                <div className="gd-pago__total">
                  <span>Total a pagar</span>
                  <strong>${new Intl.NumberFormat("de-DE").format(montoPendiente)}</strong>
                </div>
                <p className="gd-pago__nota">IVA incluido. Pago seguro con Webpay a través de Flow.</p>
              </div>

              <div style={{ marginBottom: "19px" }}>
                <Note txt={"Cuando se confirme el pago, cada firmante recibirá por correo el enlace para firmar el documento."} />
              </div>
            </CardContent>
            <div
              className="contentCotinue"
              style={{
                textAlign: "center",
                marginTop: "0px",
                marginLeft: "0px",
                marginBottom: "58px",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              {canGoBack && (
                <button
                  onClick={handleBack}
                  class="ContinueForm"
                  style={{ float: "initial", minWidth: "107px", marginRight: "37px" }}
                  type="button"
                >
                  Retroceder
                </button>
              )}
              <button
                onClick={handleButton}
                class="ContinueForm"
                style={{ float: "initial", minWidth: "107px", marginRight: "37px" }}
                type="submit"
              >
                {montoPendiente === 0 && yaPagado > 0 ? "Continuar" : "Pagar"}
              </button>
            </div>
          </Card>
        </Grid>
      </Grid>
      {/* Logos de medios de pago: en el celular se salían 8px por la derecha */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "center",
          gap: "12px 25px",
          margin: "clamp(40px, 10vw, 138px) 16px 60px",
        }}
      >
        <img style={{ height: "30px", maxWidth: "100%" }} src={flow} alt="Medio de pago flow" />
        <img style={{ height: "60px", maxWidth: "100%" }} src={webpay} alt="Medio de pago WebPay" />
      </div>
    </>
  );
}
